window.dn = window.dn || {};

/** 
 * Common functionality used on pages where user info is being edited,
 * like during registration and updating the settings page.
 */
(function (usersettings, $, undefined)
{
    var isSettingsPage = window.location.pathname.indexOf("/settings") !== -1;
    var isSalesPage = window.location.pathname.indexOf("/register/new") !== -1;

    usersettings.AutoCompleteAddress = null;
    usersettings.AutoCompleteBusiness = null;

    // Businesses we consider to be in our industry.
    var validPlaces =
    {
        "car_dealer": true,
        "car_rental": true,
        "car_repair": true
    };

    function fillInAddress(place) 
    {
        // This lets us check if the user's provided business is one we recognize as a valid business.
        var hasValidType = place.types.some(function(place) { return validPlaces[place]; });

        // Get each component of the address from the place details
        // and fill the corresponding field on the form.
        if (place && place.address_components)
        {
            for (var i = 0; i < place.address_components.length; i++) {
                var addressType = place.address_components[i].types[0];
                var street_number;
                var street;
                var street2;
                var premise; // seems to be used in places without a street number

                switch (addressType) {
                    case 'street_number':
                        street_number = place.address_components[i].short_name;
                        break;

                    case 'premise':
                        premise = place.address_components[i].long_name;
                        break;

                    case 'subpremise':
                        street2 = place.address_components[i].long_name;
                        break;

                    case 'route':
                        street = place.address_components[i].long_name;
                        break;

                    case 'locality':
                        $('#BusinessCity').val(place.address_components[i].long_name);
                        break;

                    case 'administrative_area_level_1':
                        $('#BusinessState').val(place.address_components[i].short_name).change();
                        break;

                    case 'administrative_area_level_2':
                        $('#BusinessCounty').val(place.address_components[i].long_name);
                        break;

                    case 'country':
                        $('#BusinessCountry').val(place.address_components[i].short_name).change();
                        break;

                    case 'postal_code':
                        $('#BusinessPostalCode').val(place.address_components[i].short_name);
                        break;
                }
            }

            var country = $('#BusinessCountry').val();
            if (country !== 'US' && country !== 'CA')
            {
                // clear out any state that may have been set
                $('#BusinessState').val('');
            }
        }

        var isStatedPro = ($("#IsPro").val().toLowerCase() === "true");

        if (isStatedPro && !isSettingsPage)
        {
            if (!hasValidType) 
            {
                $("#PossibleNotPro").show();
            }
            else 
            {
                $("#PossibleNotPro").hide();
            }
        }        

        var isEstablishment = ($.inArray('establishment', place.types) > -1);
        var isPremise = ($.inArray('premise', place.types) > -1);


        if (isEstablishment || isPremise) 
        { 
            $('#BusinessAddress').val(place['formatted_address']);

            if (isEstablishment) 
            {
                $('#BusinessName').val(place['name']);
            }

            if (isStatedPro)
            {
                $('#BusinessAddress').prop('disabled', true);
                $('#BusinessAddress-message').show();
                $('#BusinessStreet').val((street_number ? street_number + " " : (premise ? premise + ", " : "")) + (street || "") + (street2 ? ", " + street2 : ""));
                $('#BusinessPlaceId').val(place.place_id || "");
                $('#BusinessLatitude').val(place.geometry.location.lat());
                $('#BusinessLongitude').val(place.geometry.location.lng());
            }
            else
            {
                $('#BusinessStreet').val("");
            }
        }
    }

    function handleAddressAutocomplete() 
    {
        fillInAddress(usersettings.AutoCompleteAddress.getPlace());
    }

    function handleBusinessAutocomplete() 
    {
        fillInAddress(usersettings.AutoCompleteBusiness.getPlace());
    }

    function handleUserOrigin() 
    {
        var $option = $("#UserOrigin > option:selected");
        var moreInfoExplanation = $option.data('more-info-explanation');

        if (moreInfoExplanation)
        {
            // we do want to ask them for more info
            $('#UserOriginMoreInfo').siblings('label').text(($option.data('more-info-required') ? "" : "(Optional) ") + moreInfoExplanation);
            $('#UserOriginMoreInfo').parent().removeClass('d-none');
        }
        else
        {
            $('#UserOriginMoreInfo').parent().addClass('d-none');
        }
    }

    function onAddressManuallyChanged() 
    {
        $('#BusinessAddress').val('');
        $('#BusinessAddress').prop('disabled', false);
        $('#BusinessLatitude').val('');
        $('#BusinessLongitude').val('');
        $('#BusinessPlaceId').val('');
        $('#BusinessCounty').val('');
    }

    usersettings.ClearAddressFields = function() 
    {
        $('#BusinessStreet').val('');
        $('#BusinessCity').val('');
        $('#BusinessState').val('');
        $('#BusinessCountry').val('');
        $('#BusinessPostalCode').val('');
        $('#BusinessLatitude').val('');
        $('#BusinessLongitude').val('');
        $('#BusinessPlaceId').val('');
        $('#BusinessCounty').val('');
    };

    /**
     * Called by any page that needs to initialize and use our usersettings code.
     */
    usersettings.Init = function()
    {
        var script = document.createElement("script");
        script.src = "https://maps.googleapis.com/maps/api/js?key=" + dn.constants.ApiKeyGoogleMaps + "&libraries=places&callback=dn.usersettings.InitAutocomplete&types=address";
        script.async = "async";
        script.defer = "defer";
        document.body.appendChild(script);

        window.gm_authFailure = function() 
        {
            // There was a problem loading Google Maps API, so make a change
            // to allow users to manually handle mapping issues. 
            Sentry.captureMessage('Google Maps API is not loading!');

            // Undo the effects of the error, allowing people to manually edit their business name even when Places API fails to load
            $('input#BusinessName.gm-err-autocomplete').attr('disabled', false).css('background-image', 'none');

            // Hide the "Easy Entry" mode for business address entry when Places API fails to load.
            usersettings.ShowManualEntry();
            $('.dn-button-easy-entry').hide();
        }

        // Switch between Business/School depending on whether "Student" is the position chosen
        $('#Position').on('change', function(e) 
        {
            var find = 'School';
            var replace = 'Business';

            if ($(this).find(":selected").text() === 'Student')
            {
                find = 'Business';
                replace = 'School';
            }

            $('label').each(function(index) 
            {
                $(this).html($(this).html().replace(find, replace));
            });

            $('input').each(function(index) 
            {
                var element = $(this);

                $.each(this.attributes, function() 
                {
                    if (this.specified && (this.name.indexOf('data-val') === 0 || this.name === 'placeholder')) 
                    {
                        element.attr(this.name, this.value.replace(find, replace));
                    }
                });
            });
        });

        if (isSettingsPage)
        {
            // we want to fill in their current address as a placeholder
            var currentAddress = ($('#BusinessStreet').val() ? $('#BusinessStreet').val() + ", " : "") + $('#BusinessCity').val();
            
            if ($('#BusinessState').val())
            {
                currentAddress += ", " + $('#BusinessState').val();
            }
            if ($('#BusinessPostalCode').val())
            {
                currentAddress += " " + $('#BusinessPostalCode').val();
            } 
            
            currentAddress += ", " + $('#BusinessCountry').val();            
            $('#BusinessAddress').attr('placeholder', currentAddress);

            if (showManualAddressEntry) {
                usersettings.ShowManualEntry();
            }
        }
        else 
        {
            if (showManualAddressEntry) {
                usersettings.ShowManualEntry();
            }

            if (isSalesPage && $("#Name").length) {
                $("#Name").focus();
            }
            else if ($("#YearsExperience").length) {
                $("#YearsExperience").focus();
            }

            if ($("#UserOrigin").length && $('#UserOriginMoreInfo').length)
            {
                // Set up a change handler to show/hide our "more info" option
                $("#UserOrigin").change(handleUserOrigin);

                // run this when the form first loads
                handleUserOrigin();
            }

            if ($("#AgreedToTerms").length)
            {
                // extend jquery range validator to work for required checkboxes
                var defaultRangeValidator = $.validator.methods.range;
                $.validator.methods.range = function(value, element, param) 
                {
                    if (element.type === 'checkbox')
                    {
                        // if it's a checkbox return true if it is checked
                        return element.checked;
                    } 
                    else 
                    {
                        // otherwise run the default validation function
                        return defaultRangeValidator.call(this, value, element, param);
                    }
                }
            }
        }

        // disable ENTER for form submission
        $('form input').on
        (
            'keypress', // case sensitive, ignores CTRL/SHIFT/ALT (compared to keydown, case insensitive and doesn't ignore)
            function (e) 
            {
                return e.which !== 13;
            }
        );
    };

    usersettings.InitAutocomplete = function() 
    {
        //Whether or not the user has previously stated they are an industry professional
        var isStatedPro = ($("#IsPro").val().toLowerCase() === "true")

        // Create the autocomplete object, restricting the search to geographical
        // location types.
        if (isStatedPro)
        {
            usersettings.AutoCompleteAddress = new google.maps.places.Autocomplete
            (
                (document.getElementById('BusinessAddress')),
                {
                    types: ['address'] 
                }
            );
        } 
        else 
        {
            usersettings.AutoCompleteAddress = new google.maps.places.Autocomplete
            (
                (document.getElementById('BusinessAddress')),
                {
                    types: ['(regions)']
                }
            );
        }
            
        // When the user selects an address from the dropdown, populate the address
        // fields in the form.
        usersettings.AutoCompleteAddress.addListener('place_changed', handleAddressAutocomplete);

        // Create the autocomplete object, restricting the search to entities
        usersettings.AutoCompleteBusiness = new google.maps.places.Autocomplete
        (
            (document.getElementById('BusinessName')),
            {
                types: ['establishment'] 
            }
        );

        // When the user selects an address from the dropdown, populate the address
        // fields in the form.
        usersettings.AutoCompleteBusiness.addListener('place_changed', handleBusinessAutocomplete);
    };

    usersettings.ShowEasyEntry = function() 
    {
        $('#automatic-address').show();
        $("#manual-address").attr('hidden', true);
        $('#BusinessAddress').focus();

        $('#BusinessStreet').off('change');
        $('#BusinessCity').off('change');
        $('#BusinessState').off('change');
        //$('#BusinessCountry').off('change'); // commenting this out so that our telephone country code changer doesn't get wiped
    };

    usersettings.ShowManualEntry = function() 
    {
        $('#automatic-address').hide();
        $("#manual-address").attr('hidden', false);

        if (!isSettingsPage) {
            $('#BusinessStreet').focus();
        }

        $('#BusinessStreet').change(onAddressManuallyChanged);
        $('#BusinessCity').change(onAddressManuallyChanged);
        $('#BusinessState').change(onAddressManuallyChanged);
        $('#BusinessCountry').change(onAddressManuallyChanged);
    };

    $(document).ready
    (
        function ($)
        {
            // Process any queued functions now that the namespace is ready.
            dn.ProcessQueuedFunctions('dn.usersettings');

            var positionSelectizeName = "PositionName";
            if (document.getElementById(positionSelectizeName) != null)
            {
                // console.log("Fetching positions")
                $.get("/api/v1/position/").done(function(results) 
                {
                    constructPositionField(results)
                });

                function constructPositionField(items)
                {
                    // Positions metadata item
                    var positionMetadata = dn.constants.Metadata[7];

                    dn.metadata.CreateSelectize
                    (
                        $("#PositionId").parent(),
                        positionSelectizeName, // The Field
                        positionMetadata, // Metadata
                        {//Options Start
                            ItemsAvailable : items,
                            ItemsSelected : [],
                            MaxItems : 1,
                          //  Mode:'multi' // Single looks crappy
                        }, // Options End
                        function(itemId, $element) {}, // OnAddedFunction
                        function() {} // OnRemovedFunction
                    );

                    var id = $("#PositionId").val();
                    if (id != null && items != null)
                    {
                        for (var i = 0; i < items.length; i++)
                        {
                            if (items[i].PositionId == id)
                            {
                                dn.metadata.Selectize[positionSelectizeName].setValue(items[i].PositionName);
                            }
                        }
                    }
                }

                $("#PositionName").on("change", function()
                {
                    var selectedValue = $(this).val()
                    if (selectedValue == '')
                    {
                        $("#PositionId").val("")
                    } 
                    else 
                    {
                        var selectedId = dn.metadata.Selectize[positionSelectizeName].options[selectedValue].PositionId;
                        $("#PositionId").val(selectedId)
                    }                    
                })
            }                            
        }
    );

}(window.dn.usersettings = window.dn.usersettings || {}, jQuery));